export default __webpack_public_path__ + "static/cp-orange-c2b91b46c342ed475c3f3cdefe64c5cf.png";